import { Component, OnInit } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { SharedService, PrintingService, SessionService, RetailGameSaleRpt, RetailMessageService } from 'baseline-lib';
import { CustomToast } from '../../shared/services/custom-toast';


/**
 * Generated class for the GameSalesReportComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'game-sales-report',
  templateUrl: 'game-sales-report.html'
})
export class GameSalesReportComponent {

    _execption: any;
    _printData: string;
    _reportData: any;
    _toDate: any;
    _fromDate: any;
    _selectedGameId: any;
    _gameList: any;
    _cgli:any;
    _gameTypeList: any;
    _error: any;
    _gamecgli:any=[];
    _game:any=[];
    myDatePickerOptions: IMyDpOptions = {
      inline: false,
      editableDateField: false,
    }
    p: number;
  
    constructor(
      private _retailMessageService: RetailMessageService,
      private _sharedService: SharedService,
      private _printingService: PrintingService,
      private _sessionService: SessionService,
      private toast: CustomToast

    ) {
      this._fromDate = this._toDate = { date: { year: this._sharedService.getServerTime().getFullYear(), month: this._sharedService.getServerTime().getMonth() + 1, day: this._sharedService.getServerTime().getDate() }, jsdate: new Date() };
    }
  
    ngOnInit() {
      this._sharedService.getGameTypeList().subscribe(
        data => {
          if (data.gameTypeList) {
            this._gameTypeList = data.gameTypeList;
          }
        }
      )
    }
   
    onGameTypeClick(gameTypeId: number) {
console.log(gameTypeId);
  
      this._selectedGameId = '';
      if (gameTypeId) {
        this._sharedService.getGameListById(gameTypeId).subscribe(
          data => {
            console.log(data);
            
            if (data.gli) {
              this._gameList = data.gli;
              this._game=[];
              console.log(this._gameList);
              for(var i=0;i<this._gameList.length;i++)
               {
                  this._game=this._game.concat(this._gameList[i].cgli);
               }              
             console.log(this._game);
             
            }
            else{
              this._game=[];

            }
          }
        )
      }
    }
  
  
    onGameClick(gameId: any) {
      this._selectedGameId = gameId;
      console.log(this._selectedGameId);
      
    }
  
    validateReport(): boolean {
      this._reportData = '';
      this._execption = '';
      this._error = '';
  
      if (!this._selectedGameId) {
        this._execption = 'Please select game first.'
        this.toast.showError(this._execption);

        setTimeout(() => {
          this._execption = '';
        }, 3000);
        return false;
      }
      if (!this._fromDate || !this._toDate) {
        this._execption = 'Please select date.'
        this.toast.showError(this._execption);

        setTimeout(() => {
          this._execption = '';
        }, 3000);
        return false;
      }
      if (this._fromDate.jsdate > this._toDate.jsdate) {      
        this._execption = 'To date should be greater than from date'
        this.toast.showError(this._execption);

        setTimeout(() => {
          this._execption = '';
        }, 3000);
        return false;
      }
  
      return true;
    }
  
  
    getGameSalesRpt() {
      if (this.validateReport()) {      
        let gameSaleRpt = new RetailGameSaleRpt();
        if (this._sessionService.getAuthUser()) {
          this._sharedService.showLoader();
          gameSaleRpt.gid = this._selectedGameId; // hard code for now         
          gameSaleRpt.tokenId = this._sessionService.getAuthUser().tokenNo;
          gameSaleRpt.fd = this._sharedService.getFormatedDate(this._fromDate);
          gameSaleRpt.td = this._sharedService.getFormatedDate(this._toDate);
          this._retailMessageService.getGameSaleRpt(gameSaleRpt).subscribe(
            data => {
              this._sharedService.hideLoader();
              if (data.balanceRepostList) {
                this._reportData = data.balanceRepostList;

              }
              else {
                this._execption = data.msg;
                this.toast.showError(this._execption);

                setTimeout(() => {
                  this._execption = '';
                }, 3000);
              }
            },
            error => {
              this.toast.showError(error.message);

              this._sharedService.hideLoader();
              if (error.msg) {

                this._error = error.msg;
                this.toast.showError(this._error);

                setTimeout(() => {
                  this._error= '';
                }, 3000);
              }
              else {

                this._error = error.message;
                this.toast.showError(this._error);

                setTimeout(() => {
                  this._error= '';
                }, 3000);
              }
              this.toast.showError(this._error);

              // console.log(error)
            }
          )
        }
      }
    }
  
    printReport() {
      // this._printData = "retailSaleReport"
      // this._printingService.printDetails(this._printData);
      this._printingService.printRetailerReport();
    }
  
  }
  



// WEBPACK FOOTER //
// ./src/app/retailer/game-sales-report/game-sales-report.ts